import { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { Sheet, SheetContent, SheetTitle, SheetDescription } from '../components/ui/sheet';
import { usePortalDestination } from './PortalDestinationContext';
import { PortalIdentity, PortalDestinationPicker } from './PortalIdentity';
import { buildPharmacyTokens } from './lib/portalTheme';
import { usePortalTheme } from './PortalThemeContext';

/** Tapping the pharmacy identity opens a bottom sheet for pharmacy and branch selection. */
export const PortalIdentitySheet = () => {
  const { pharmacy, branch, pickerOpen, openPicker, closePicker } = usePortalDestination();
  const { theme } = usePortalTheme();
  useEffect(() => { closePicker(); }, [pharmacy?.tenant_id, branch?.tenant_id]);
  return <>
    <button type="button" className="portal-identity-trigger" onClick={openPicker}
      aria-haspopup="dialog" data-testid="portal-identity-trigger">
      <PortalIdentity />
      <ChevronDown size={16} className="portal-identity-chevron" aria-hidden="true" />
    </button>
    <Sheet open={pickerOpen} onOpenChange={(next) => (next ? openPicker() : closePicker())}>
      <SheetContent side="bottom" className="portal-brand portal-mobile-sheet portal-pharmacy-sheet" data-testid="portal-pharmacy-sheet"
        closeProps={{ 'data-testid': 'portal-pharmacy-sheet-close', 'aria-label': 'Close pharmacy selector' }}
        style={buildPharmacyTokens(pharmacy, theme)}>
        <div className="portal-sheet-handle" aria-hidden="true" />
        <SheetTitle className="text-left" data-testid="portal-pharmacy-sheet-title">Choose pharmacy</SheetTitle>
        <SheetDescription className="sr-only">Select your pharmacy and service branch</SheetDescription>
        <PortalDestinationPicker bare />
      </SheetContent>
    </Sheet>
  </>;
};
